<template>
    <v-card class="ma-0 pa-3 wrapper">
        <v-container class="pa-0 d-flex align-center justify-space-between gap-8">
            <div class="d-flex align-center gap-2">
                <v-chip
                    label
                    class="product-label"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5 7.5C15.5 7.95963 15.4095 8.41475 15.2336 8.83939C15.0577 9.26403 14.7999 9.64987 14.4749 9.97487C14.1499 10.2999 13.764 10.5577 13.3394 10.7336C12.9148 10.9095 12.4596 11 12 11C11.5404 11 11.0852 10.9095 10.6606 10.7336C10.236 10.5577 9.85013 10.2999 9.52513 9.97487C9.20012 9.64987 8.94231 9.26403 8.76642 8.83939C8.59053 8.41475 8.5 7.95963 8.5 7.5C8.5 6.57174 8.86875 5.6815 9.52513 5.02513C10.1815 4.36875 11.0717 4 12 4C12.9283 4 13.8185 4.36875 14.4749 5.02513C15.1313 5.6815 15.5 6.57174 15.5 7.5Z" fill="#0066FF"/>
                    <path opacity="0.4" d="M19.5 7.5C19.5 8.16304 19.2366 8.79893 18.7678 9.26777C18.2989 9.73661 17.663 10 17 10C16.337 10 15.7011 9.73661 15.2322 9.26777C14.7634 8.79893 14.5 8.16304 14.5 7.5C14.5 6.83696 14.7634 6.20107 15.2322 5.73223C15.7011 5.26339 16.337 5 17 5C17.663 5 18.2989 5.26339 18.7678 5.73223C19.2366 6.20107 19.5 6.83696 19.5 7.5ZM4.5 7.5C4.5 8.16304 4.76339 8.79893 5.23223 9.26777C5.70107 9.73661 6.33696 10 7 10C7.66304 10 8.29893 9.73661 8.76777 9.26777C9.23661 8.79893 9.5 8.16304 9.5 7.5C9.5 6.83696 9.23661 6.20107 8.76777 5.73223C8.29893 5.26339 7.66304 5 7 5C6.33696 5 5.70107 5.26339 5.23223 5.73223C4.76339 6.20107 4.5 6.83696 4.5 7.5Z" fill="#0066FF"/>
                    <path d="M18 16.5C18 18.433 15.314 20 12 20C8.686 20 6 18.433 6 16.5C6 14.567 8.686 13 12 13C15.314 13 18 14.567 18 16.5Z" fill="#0066FF"/>
                    <path opacity="0.4" d="M22 16.5C22 17.88 20.21 19 18 19C15.79 19 14 17.88 14 16.5C14 15.12 15.79 14 18 14C20.21 14 22 15.12 22 16.5ZM2 16.5C2 17.88 3.79 19 6 19C8.21 19 10 17.88 10 16.5C10 15.12 8.21 14 6 14C3.79 14 2 15.12 2 16.5Z" fill="#0066FF"/>
                    </svg>
                </v-chip>
                <v-card-text class="pa-0 text-body-2">{{ $t('new-customer') }}</v-card-text>
            </div>
            <!-- <v-select
                :items="items"
                label="امروز"
                dense
                append-icon="mdi-chevron-down"
                class="mt-0"
                style="width: 0;"
            >
            </v-select> -->
        </v-container>
        <v-card-text class="pa-0 text-caption white--text mt-4 mb-6" style="width: 150px;">
          {{ $t('new customers added to your business.') }}
        </v-card-text>
        <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <v-container
            v-if="newCustomersCount != null && newCustomersCount != undefined"
            class="pa-0 d-flex align-center gap-2"
          >
              <v-card-text
                class="pa-0 text-body-1"
              >
              {{ newCustomersCount }}
              </v-card-text>
              <v-card-text class="pa-0 text-caption white--text">{{ $t('per-person') }}</v-card-text>
          </v-container>
          <v-container
            v-if="newCustomersCount == null && newCustomersCount == undefined"
            class="pa-0"
          >
            <v-card-text class="pa-0 text-caption">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </v-container>
        </div>
        <div v-else>
          <v-card-text class="pa-0 text-caption">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      newCustomersCount: null
    }
  },
  methods: {
    fetchList () {
      this.$axios.get(this.$endpoint + 'widgets', {
        params: {
          type: 'newCustomer'
        }
      })
        .then(r => {
          this.newCustomersCount = r.data
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.wrapper {
    background-color: #0066FF;
    padding: 10px;
    color: #fff;
}
.product-label {
    padding: 0 !important;
    width: 35px;
    height: 33px;
    background: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.v-card__text {
    width: auto;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
    border-color: transparent !important;
}
::v-deep .v-text-field.v-input--dense .v-label {
    top: 0 !important;
}
::v-deep .v-label.v-label {
    font-size: 10px !important;
    color: #fff;
}
::v-deep .v-icon.v-icon {
    color: #fff;
    font-size: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
